"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function AuthInput(_a) {
    var className = _a.className, adornment = _a.adornment, props = __rest(_a, ["className", "adornment"]);
    return (react_1.default.createElement("div", { className: "w-full relative" },
        react_1.default.createElement("input", __assign({}, props, { className: "px-4 py-2 placeholder-gray-300 backdrop-filter backdrop-blur rounded-md w-full bg-white bg-opacity-20 border border-transparent hover:border-white hover:border-opacity-50 focus:border-white focus:border-opacity-50 transition-colors ".concat(className) })),
        react_1.default.createElement("div", { className: "absolute right-0 top-0 bottom-0 flex items-center" }, adornment)));
}
exports.default = AuthInput;
